import { Button, styled } from '@mui/material'
import { memo } from 'react'
import { useNotificationPagination } from './index'

const Clear = styled(Button)`
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  height: 24px;
  border-radius: 4px;
  color: rgba(160, 238, 9, 1);
  background-color: transparent;
  &:hover {
    background-color: rgba(45, 51, 58, 0.5);
  }
`

export const ButtonClear = memo(() => {
  const { list, clear } = useNotificationPagination()

  if (!list?.length) {
    return null
  }

  return <Clear onClick={() => clear()}>Clear all</Clear>
})
